import styled from 'styled-components';

import { ColorName } from 'types';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

export type StyledCustomerStatusProps = {
  background: ColorName;
};

const Container = styled.div<StyledCustomerStatusProps>`
  display: inline-block;

  padding: 0.1rem 0.6rem;

  background-color: ${({ background }) => pickColor(background)};
  border-radius: ${({ theme }) => theme.borderRadius.big};
`;

const Label = styled(Headline)`
  white-space: nowrap;

  font-size: 1.2rem;
`;

export { Container, Label };
